import apiClient from '@/services/axios';

export async function testTargetingCount(data) {
  const response = await apiClient.post('/recurringNotifications/test-targeting-count', data);
  if (response) {
    return response.data;
  }
  throw new Error('Unable to test targeting count.');
}
